import React from 'react';

export default function Cactus() {
	return (
		<g>
			<path fill="#75C69F" d="M95.82006,292.11142c-4.41797,0-8,3.58154-8,8v6.03125c0,4.19385-1.00977,7.23389-3.08691,9.29395
				c-1.38525,1.37384-3.12183,2.21136-4.73828,2.72797v-42.40912c0-5.79883-4.70117-10.5-10.5-10.5s-10.5,4.70117-10.5,10.5v29.10162
				c-1.59521-0.51007-3.30908-1.32874-4.67383-2.65631c-2.12012-2.06201-3.15039-5.12207-3.15039-9.35645v-6.03076
				c0-4.41846-3.58203-8-8-8s-8,3.58154-8,8v6.03076c0,10.78613,4.34766,17.27832,7.99414,20.82568
				c5.14209,5.00116,11.4397,6.88812,15.83008,7.59747v34.07489c0,5.79883,4.70117,10.5,10.5,10.5s10.5-4.70117,10.5-10.5v-20.77673
				c4.39062-0.70923,10.68872-2.59601,15.83105-7.59729c3.64648-3.54736,7.99414-10.03955,7.99414-20.82568v-6.03125
				C103.82006,295.69296,100.23803,292.11142,95.82006,292.11142z" />
			<polygon fill="#D1AF79" points="96.50246,345.14954 93.84914,345.14954 93.84914,345.14771 45.14065,345.14771 45.14065,345.14954
				42.34182,345.14954 43.67385,360.37219 46.47268,360.37219 48.74465,386.33661 69.49465,386.33661 90.24563,386.33661
				92.51711,360.37219 95.1719,360.37219 	" />
			<polygon fill="#CEA365" points="92.51717,360.37219 46.47284,360.37219 46.80064,364.12 92.18935,364.12 		" />
		</g>
	);
}



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Toy/Cactus.js